import React from "react";
import classess from "./style.module.scss";

export const NormalCheckbox = ({
  name,
  id,
  className,
  onChange,
  checked,
  label,
  labelClassName = "fs-16 fw-400 ps-2",
  defaultChecked,
  type
}) => {
  return (
    <fieldset color-scheme="darkBrown">
      <div className="form-accept-group">
        <input
          type= {type || "checkbox"}
          name={name}
          id={id}
          className={`${classess.checkbox} checkboxdata`}
          onChange={onChange}
          checked={checked}
          defaultChecked={defaultChecked}
        />
        {label && <label className={labelClassName}>{label}</label>}
      </div>
    </fieldset>
  );
};
